import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { ProductMockup } from '../components/ProductMockup';
import { ConflictSection } from '../components/ConflictSection';
import { SolutionSection } from '../components/SolutionSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans selection:bg-black selection:text-white" data-id="element-81">
      <UrgencyBar data-id="element-82" />
      <main data-id="element-83">
        <HeroSection data-id="element-84" />
        <ProductMockup data-id="element-85" />
        <ConflictSection data-id="element-86" />
        <SolutionSection data-id="element-87" />
        <TestimonialsSection data-id="element-88" />
        <GuaranteeSection data-id="element-89" />
        <PricingSection data-id="element-90" />
      </main>
      <Footer data-id="element-91" />
    </div>;
}